import React, {
  useState,
  useRef,
  useContext,
  useEffect,
  Fragment,
} from "react";
import PropTypes from "prop-types";
import { HelpModeContext } from "./Contexts";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import { ComboBoxComponent } from "@syncfusion/ej2-react-dropdowns";
import { ListBoxComponent } from "@syncfusion/ej2-react-dropdowns";
import RequirementsEditor from "./RequirementsEditor";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import ProjectTitleBar from "./ProjectTitleBar_ably";
import RequirementsSynopsis from "./RequirementsSynopsis";
import "./styles/Requirements.css";

function RequirementsEditScreen(props) {
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const helpMode = useContext(HelpModeContext).mode;
  const newReq = useRef(props.newReq);
  let categoryDropdownList = [];
  const lists = useRef({});
  const [synopsis, setSynopsis] = useState(newReq.current.synopsis);
  const dropdownFieldDef = { text: "name", value: "id" };
  const approvalMembers = useRef(props.approvalMembers);
  const acknowledgementMembers = useRef(props.acknowledgementMembers);
  let transferListFields = { text: "name", value: "id" };
  let transferListToolbar = {
    items: ["moveTo", "moveFrom", "moveAllTo", "moveAllFrom"],
  };
  const projectTeam = useRef(props.projectTeam);
  const [dirty, isDirty] = useState(false);
  const [openRequiredFieldNotification, setOpenRequiredFieldNotification] =
    useState(false);
  const idToDelete = useRef();
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const APPROVED_STAGE_ID = useRef();
  const PROPOSED_STAGE_ID = useRef();
  const oadaSettingsRaw = localStorage.getItem("oadaSettings");
  if (oadaSettingsRaw) {
    const oadaSettings = JSON.parse(oadaSettingsRaw);
    APPROVED_STAGE_ID.current =
      oadaSettings["approvedRequirementStageDropdown_options"];
    PROPOSED_STAGE_ID.current =
      oadaSettings["proposedRequirementStageDropdown_options"];
  }
  const stageOptions = [
    { name: "Proposed", id: PROPOSED_STAGE_ID.current },
    { name: "Approved", id: APPROVED_STAGE_ID.current },
  ];
  const handleEditorContentsChange = (event) => {
    newReq.current.details = event.value;
  };

  const reqEditor = (
    <RequirementsEditor
      handleEditorContentsChange={handleEditorContentsChange}
      reqDetails={newReq.current.details}
      prevDetails={newReq.current.previousDetails}
      prevApprovedDetails={newReq.current.previousApprovedDetails}
      height="100px"
      showComparisons={true}
      changeLog={newReq.current.changeLog}
    />
  );

  /*
  old category list model from tree
  if (props.categoryDropdownFields.dataSource) {
    categoryDropdownList = processNodeArray(
      props.categoryDropdownFields.dataSource,
      [],
      "",
    );
    //categoryDropdownList.shift(); // remove 00 option
  } else {
    const localReqCategories = localStorage.getItem(
      "reqCategories" + projectObject.id,
    );
    if (localReqCategories) {
      categoryDropdownList = processNodeArray(
        JSON.parse(localReqCategories),
        [],
        "",
      );
    }
  }*/

  categoryDropdownList = projectObject.oada_req_categories__c.split("||");
  /*function processNodeArray(nodeArray, outputArray, parentText) {
    if (parentText != "") {
      parentText += ": ";
    }
    for (let x = 0; x < nodeArray.length; x++) {
      outputArray.push({
        name: parentText + nodeArray[x].nodeText,
        id: nodeArray[x].nodeId.toString(),
      });
      if (nodeArray[x].nodeChild) {
        outputArray = processNodeArray(
          nodeArray[x].nodeChild,
          outputArray,
          parentText + nodeArray[x].nodeText,
        );
      }
    }
    return outputArray;
  }*/

  const handleNotificationClose = () => {
    setOpenRequiredFieldNotification(false);
  };

  const handleSynopsisFieldValueChange = (value) => {
    newReq.current.synopsis = value;
    if (value.length == 1) {
      setSynopsis(event.target.value);
    }
  };

  const handleStageValueChange = (event) => {
    newReq.current.stageId = event.itemData.id;
  };

  const handleCategoryValueChange = (event) => {
    //newReq.current.categoryId = event.itemData.id;
    newReq.current.categoryName = event.value;
  };

  const handleListBoxChange = (event) => {
    if (event.elements.length > 0) {
      const listId = event.elements[0].parentElement.id;
      if (listId == "leftlistbox_parent") {
        lists.current.center.selectAll(false);
        lists.current.right.selectAll(false);
      }
      if (listId == "centerlistbox_parent") {
        lists.current.left.selectAll(false);
        lists.current.right.selectAll(false);
      }
      if (listId == "rightlistbox_parent") {
        lists.current.center.selectAll(false);
        lists.current.left.selectAll(false);
      }
    }
  };

  // moveTo eventName on Center = moving from Center to Right
  // moveFrom eventName on Right = moving from Right to Center
  // moveFrom eventName on Center = moving from Center to Left
  // moveTo eventName on Left = moving from Left to Center

  const actionCompleteLeft = (event) => {
    if (event.eventName == "moveTo") {
      const indexToRemove = approvalMembers.current.findIndex(
        (elem) => elem.id == event.items[0].id,
      );
      approvalMembers.current.splice(indexToRemove, 1);
    }
  };

  const actionCompleteCenter = (event) => {
    if (event.eventName == "moveTo") {
      acknowledgementMembers.current.push(event.items[0]);
    }
    if (event.eventName == "moveFrom") {
      approvalMembers.current.push(event.items[0]);
    }
  };

  const actionCompleteRight = (event) => {
    if (event.eventName == "moveFrom") {
      const indexToRemove = acknowledgementMembers.current.findIndex(
        (elem) => elem.id == event.items[0].id,
      );
      acknowledgementMembers.current.splice(indexToRemove, 1);
    }
  };

  function saveRequirement() {
    let approvalMembersString = "";
    let acknowledgementMembersString = "";

    approvalMembers.current.forEach((approvalObject) => {
      approvalMembersString +=
        approvalObject.name + "[id" + approvalObject.id + "],";
    });
    //remove last comma
    approvalMembersString = approvalMembersString.substring(
      0,
      approvalMembersString.length - 1,
    );

    acknowledgementMembers.current.forEach((acknowledgementObject) => {
      acknowledgementMembersString +=
        acknowledgementObject.name + "[id" + acknowledgementObject.id + "],";
    });
    //remove last comma
    acknowledgementMembersString = acknowledgementMembersString.substring(
      0,
      acknowledgementMembersString.length - 1,
    );

    if (newReq.current.id) {
      // update
      const reqArrayId = newReq.current.id;
      const originalReqIndex = props.originalReqArray.current.findIndex(
        (elem) => elem.id == reqArrayId,
      );
      props.originalReqArray.current[originalReqIndex].oada_req_approvals__c ==
        approvalMembersString;
      props.originalReqArray.current[originalReqIndex]
        .oada_req_acknowledgements__c == acknowledgementMembersString;
      props.updateRequirement(
        newReq.current,
        approvalMembersString,
        acknowledgementMembersString,
        newReq.current.details,
      );
    } else {
      // add
      props.addRequirement(
        newReq.current,
        approvalMembersString,
        acknowledgementMembersString,
        newReq.current.details,
      );
    }
  }

  const handleSave = () => {
    if (newReq.current.synopsis && newReq.current.stageId) {
      saveRequirement();

      props.handleClose();
      isDirty(!dirty);
    } else {
      setOpenRequiredFieldNotification(true);
    }
  };

  const handleSaveCreate = () => {
    if (newReq.current.synopsis && newReq.current.stageId) {
      saveRequirement();
      newReq.current.details = "";
      newReq.current.previousDetails = "";
      newReq.current.previousApprovedDetails = "";
      newReq.current.synopsis = "";

      setSynopsis("");
    } else {
      setOpenRequiredFieldNotification(true);
    }
  };

  const handleDeleteConfirm = () => {
    idToDelete.current = newReq.current.id;
    //props.handleClose();
    setOpenDeleteConfirm(true);
  };

  const handleCloseDeleteConfirm = (event) => {
    console.log(event.target.value);
    setOpenDeleteConfirm(false);
    if (event.target.value == "confirm") {
      handleDelete(idToDelete.current);
    }
    isDirty(!dirty);
  };

  const handleDelete = (reqId) => {
    props.deleteRequirement(reqId);
    props.handleClose();
  };

  return (
    <Box
      sx={{
        backgroundColor: "gainsboro",
        padding: "10px",
        border: "solid 2px",
        overflowY: "auto",
        height: "95vh",
      }}
    >
      <ProjectTitleBar
        projectObject={projectObject}
        docPage="REQUIREMENTS TAB.pdf"
        inDialog={true}
      />
      <br></br>
      <br></br>

      <Box
        sx={{
          backgroundColor: "gainsboro",
          padding: "10px",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <Typography className="reqAccordionHeaderShort">
          Requirement Synopsis
        </Typography>
        <Typography
          id="name"
          sx={{
            margin: "0px 10px",
            width: "100px",
            color: "white",
            fontWeight: "bold",
            backgroundColor: "#643f69",
            borderRadius: "10px",
            textAlign: "center",
          }}
        >
          {newReq.current.name}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: "white",
          paddingTop: "20px",
        }}
      >
        <Fragment>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell colSpan={2} className="reqDetailsTableCell">
                  <RequirementsSynopsis
                    synopsis={synopsis}
                    handleSynopsisChange={handleSynopsisFieldValueChange}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="35%" className="reqDetailsTableCell">
                  <DropDownListComponent
                    sortOrder="Ascending"
                    required
                    id="__reqStage"
                    //ref={(r2) => (refStage = r2)}
                    defaultValue={newReq.current.stage}
                    dataSource={stageOptions}
                    fields={dropdownFieldDef}
                    select={handleStageValueChange}
                    placeholder="&nbsp;&nbsp;&nbsp;Stage *"
                    width="350px"
                    cssClass="reqDialogDropdown"
                    floatLabelType="Always"
                  />
                  <br></br>
                  <br></br>
                  <ComboBoxComponent
                    sortOrder="Ascending"
                    id="__reqCategory"
                    //ref={(r3) => (refCategory = r3)}
                    defaultValue={newReq.current.categoryName} // was category
                    dataSource={categoryDropdownList}
                    //fields={dropdownFieldDef}
                    change={handleCategoryValueChange}
                    placeholder="&nbsp;&nbsp;&nbsp;Category (make a selection or type in a new category)"
                    width="350px"
                    cssClass="reqDialogDropdown"
                    floatLabelType="Always"
                  />
                </TableCell>
                <TableCell className="reqDetailsTableCell">
                  <Box
                    display="inline-block"
                    sx={{ padding: "10px 0px 0px 0px" }}
                  >
                    <Box
                      className="dashTableTitleBar"
                      sx={{ backgroundColor: "#643f69" }}
                    >
                      <div>&nbsp;</div>
                      <div
                        id="__reqApprovals"
                        style={{
                          padding: "0px 7px",
                          borderRadius: "5px",
                          cursor: helpMode ? "pointer" : "default",
                        }}
                      >
                        Approvals
                      </div>
                      <div>&nbsp;&nbsp;&nbsp;</div>
                      <div
                        id="__reqUnassigned"
                        style={{
                          backgroundColor: "#643f69",
                          padding: "0px 7px",
                          borderRadius: "5px",
                          cursor: helpMode ? "pointer" : "default",
                        }}
                      >
                        Unassigned
                      </div>
                      <div>&nbsp;</div>
                      <div
                        id="__reqAcknowledgements"
                        style={{
                          padding: "0px 7px",
                          borderRadius: "5px",
                          cursor: helpMode ? "pointer" : "default",
                        }}
                      >
                        Acknowledgements
                      </div>
                      <div></div>
                    </Box>

                    <ListBoxComponent
                      ref={(leftRef) => (lists.current.left = leftRef)}
                      id="leftlistbox"
                      sortOrder="Ascending"
                      dataSource={approvalMembers.current}
                      fields={transferListFields}
                      scope="#centerlistbox"
                      toolbarSettings={transferListToolbar}
                      cssClass="reqDualListLeft"
                      change={handleListBoxChange}
                      actionComplete={actionCompleteLeft}
                    />
                    <ListBoxComponent
                      ref={(centerRef) => (lists.current.center = centerRef)}
                      id="centerlistbox"
                      sortOrder="Ascending"
                      dataSource={projectTeam.current}
                      fields={transferListFields}
                      scope="#rightlistbox"
                      toolbarSettings={transferListToolbar}
                      cssClass="reqDualListCenter"
                      change={handleListBoxChange}
                      actionComplete={actionCompleteCenter}
                    />
                    <ListBoxComponent
                      ref={(rightRef) => (lists.current.right = rightRef)}
                      id="rightlistbox"
                      sortOrder="Ascending"
                      dataSource={acknowledgementMembers.current}
                      fields={transferListFields}
                      cssClass="reqDualListRight"
                      change={handleListBoxChange}
                      actionComplete={actionCompleteRight}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Fragment>
        <br></br>
        <Box
          sx={{
            backgroundColor: "gainsboro",
            padding: "10px",
          }}
        >
          <Typography className="reqAccordionHeader">
            Requirement Details
          </Typography>
        </Box>
        <Box height={350} sx={{ backgroundColor: "gainsboro" }}>
          {reqEditor}
        </Box>
      </Box>
      <Box sx={{ width: "100%", justifyContent: "center" }}>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            className="dialogConfirmCancelButton"
            onClick={props.handleClose}
            sx={{ marginRight: "20px" }}
          >
            Cancel
          </Button>
          <Button
            className="dialogConfirmCancelButton"
            onClick={handleSave}
            sx={{ marginRight: "20px" }}
          >
            Save
          </Button>

          {newReq.current.name ? (
            <Button
              className="dialogDeleteButton"
              onClick={handleDeleteConfirm}
            >
              Delete
            </Button>
          ) : (
            <Button
              className="dialogConfirmCancelButtonWide"
              onClick={handleSaveCreate}
            >
              Save and Create Another
            </Button>
          )}
        </DialogActions>
      </Box>
      <Dialog open={openDeleteConfirm} onClose={handleCloseDeleteConfirm}>
        <DialogTitle id="alert-dialog-title">
          {"Delete Requirement?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You have requested to delete this requirement. Please confirm this
            action.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteConfirm} value="cancel" autoFocus>
            Cancel
          </Button>
          <Button onClick={handleCloseDeleteConfirm} value="confirm">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openRequiredFieldNotification}
        autoHideDuration={5000}
        onClose={handleNotificationClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          variant="filled"
          onClose={handleNotificationClose}
          severity="error"
          sx={{ width: "100%", fontSize: "large" }}
        >
          Save failed - Synopsis and Stage are required fields.
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default RequirementsEditScreen;

RequirementsEditScreen.propTypes = {
  categoryDropdownFields: PropTypes.object,
  updateRequirement: PropTypes.func,
  addRequirement: PropTypes.func,
  deleteRequirement: PropTypes.func,
  originalReqArray: PropTypes.object,
  handleClose: PropTypes.func,
  newReq: PropTypes.object,
  projectTeam: PropTypes.array,
  approvalMembers: PropTypes.array,
  acknowledgementMembers: PropTypes.array,
};

/*
 <Accordion className="reqAccordion">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className="reqAccordionHeader">
              Comparison from previous version
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ReactDiffViewer
              oldValue={Tools.removeTags(newReq.current.previousDetails)}
              newValue={Tools.removeTags(newReq.current.details)}
              styles={diffStyles}
              compareMethod={DiffMethod.WORDS}
              splitView={true}
              //showDiffOnly={true}
              //extraLinesSurroundingDiff={0}
            />
          </AccordionDetails>
        </Accordion>
        
        
        
        
                  <TextField
                    required
                    id="__reqSynopsis"
                    value={synopsis}
                    onChange={handleSynopsisFieldValueChange}
                    variant="standard"
                    label="Synopsis"
                    sx={{
                      margin: "0px 10px",
                      width: "1000px",
                    }}
                  ></TextField>*/
